import { render, staticRenderFns } from "./MultiManuscriptEditorFooter.vue?vue&type=template&id=7e044798&scoped=true"
import script from "./MultiManuscriptEditorFooter.vue?vue&type=script&lang=ts"
export * from "./MultiManuscriptEditorFooter.vue?vue&type=script&lang=ts"
import style0 from "./MultiManuscriptEditorFooter.vue?vue&type=style&index=0&id=7e044798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e044798",
  null
  
)

export default component.exports